import styled from 'styled-components';

import { BLACK, LIGHT_GRAY, LABEL } from 'root/theme';

const SubCategoryRowContainer = styled.div`
  border-bottom: 0.25px solid ${LIGHT_GRAY};
  width: 100%;
  margin-bottom: 30px;
`;

const QuizRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px 5px 0px;
`;

const QuizName = styled.div`
  color: ${BLACK};
  font-size: 1.1 rem;
  width: 90%;
`;

const ScoreRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0px 0px 5px 0px;
`;

const QuizButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.kind === `S` ? `flex-end` : `space-between`};
  min-width: 127px;
  margin-right: 0px;
  ${(props) => props.kind === `S` && `margin-right: 0px`};
`;

const ScoreSection = styled(QuizButtons)`
`;

const ScoreLabel = styled.p`
  ${LABEL}
`;

export {
  SubCategoryRowContainer,
  QuizName,
  QuizRow,
  QuizButtons,
  ScoreRow,
  ScoreSection,
  ScoreLabel,
};
